<ngx-paypal [config]="payPalConfig" *ngIf="!isLoading else isLoadingTemplate"></ngx-paypal>

<ng-template #isLoadingTemplate>
  <button disabled class="col-12 col-sm-10 btn border-0 d-flex align-items-center justify-content-center py-2">
    <div class="spinner-border text-primary"></div>
  </button>
</ng-template>
